import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthenticated, selectUser } from '../auth/authSlice';
import { STATUS, closeExpediente, loadExpediente, persistExpediente, editExpediente } from './expedienteSlice';
import { escenarios, plataformas, tiposViolencia, ambitos, motivosCierre } from '../../app/utils.js';
import {traeResponsablesPlataformas} from '../plataforma/plataformaAPI.js';
import Actuaciones from './actuacion/Actuaciones';
import Login from '../auth/Login';
import Spinner from '../../components/Spinner';

export default function EditarExpediente () {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    /* useEffect(() => {
        if (!userAuthenticated) {
            navigate('/login');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [userAuthenticated]); */
    
    // si no recibo ningún número de expediente,
    // se trata de añadir y no de editar
    const {num} = useParams();
    const { expediente, status, error } = useSelector((state) => state.expediente);
    const userAuthenticated = useSelector(selectAuthenticated);
    const user = useSelector(selectUser);
    const [responsable, setResponsable] = useState('');
    const [medida, setMedida] = useState('');
    const [resultado, setResultado] = useState('');
    const [notificadoEntidad, setNotificadoEntidad] = useState(false);

    useEffect(()=>{
        if (!isNaN(parseInt(num))) {
            if (status !== STATUS.UNSAVED) {
                dispatch(loadExpediente(num));
            }
        } 
    }, [num]);

    useEffect(() => {
        if (num && status === STATUS.SAVED && expediente && expediente.numero) {
            if (!(expediente.abierto) && !(user.responsable_spiyv)){
                navigate(`/expediente/${expediente.numero}/ver`);
            }
        }
    }, [status, expediente]);

    if (!userAuthenticated) {
        return <Login />;
    }

    async function getResponsable(plataforma) {
        try {
            const response = await traeResponsablesPlataformas();
            if (response.ok) {
                const plataformas = await response.json();
                const plataformaInfo = plataformas.find((plat) => plat.nombre === plataforma);
                return plataformaInfo.responsable;
            } else {
                return '';
            }
        } catch (error) {
            return '';
        }
    }
    
    function onClickHandler({target}) {
        if (target.id === 'expediente') {
            navigate(`/expediente/${num}`);
            return;
        }

        // el resto de opciones implican guardado
        if (medida) {
            dispatch(editExpediente({
                key: 'medidas',
                value: [...expediente.medidas, {texto_medida: medida, escrito_por: user.email}]
            }));
            setMedida('');
        }
        if (resultado) {
            dispatch(editExpediente({
                key: 'resultados',
                value: [...expediente.resultados, {texto_resultado: resultado, escrito_por: user.email}]
            }));
            setResultado('');
        }
        
        if (target.id==='cerrar'){
            dispatch(closeExpediente());
        }

        if (expediente.cierre?.motivo_cierre && ! expediente.cierre?.fecha_medida) {
            alert('Es necesario introducir la fecha en la que se tomó la medida que origina la propuesta de cierre del expediente.');
            return;
        }

        dispatch(persistExpediente());
        //dispatch(loadExpediente(num));
    }    

    async function onChangeHandler({target}) {
        const userInput = target.value;
        let field = target.id;
        if (field === 'medidas') {
            setMedida(userInput);
            return;
        }
        if (field === 'resultados') {
            setResultado(userInput);
            return;
        }
        if (field === 'cierre.notificado_a_entidad_publica') {
            const checked = !notificadoEntidad;
            setNotificadoEntidad(checked);
            dispatch(editExpediente({
                key: field,
                value: checked
            }));
            return;
        }

        dispatch(editExpediente({
            key: field,
            value: userInput
        }));
        if (field === 'plataforma') {
            field = 'responsable';
            const responsablePlataforma = await getResponsable(userInput);
            setResponsable(responsablePlataforma);
            dispatch(editExpediente({
                key: field,
                value: responsable
            }));
        }
        if (field === 'cierre.motivo_cierre') {
            const checked = isNotificadoEntidad(userInput);
            setNotificadoEntidad(checked);
            field = 'cierre.notificado_a_entidad_publica';
            dispatch(editExpediente({
                key: field,
                value: checked
            }));
        }
    }

    function isNotificadoEntidad(motivoCierre) {
        const motivosConNotificacion = [
            'Se ha puesto en conocimiento de Cuerpos y Fuerzas de Seguridad',
            'Se ha puesto en conocimiento de los Servicios Sociales',
            'Se ha puesto en conocimiento de Fiscalía'
        ];
        return motivosConNotificacion.includes(motivoCierre);
    }

    if (status === STATUS.LOADING) {
        return <Spinner/>;
    }

    if (error === STATUS.COULDNT_LOAD) {
        return (
            <> 
                <div className='title'>
                    <h2>ERROR: No hay ningún expediente con nº {num}</h2>
                </div>
                <button id='volver' onClick={() => navigate('/')}>Volver a inicio</button>
            </>
        );
    }

    if (status === STATUS.SAVING) {
        return (<>
            <p>Guardando...</p>
            <Spinner/>
        </>
        );
    }

    if (error === STATUS.COULDNT_SAVE) {
        return (<div className='title'>
            <h2>ERROR: No se ha podido guardar.</h2>
        </div>);
    }

    return (
        <> 
            { status === STATUS.SAVING 
                ? <>
                    <p>Guardando...</p>
                    <Spinner/>
                </>
                : ''
            }
            { error === STATUS.COULDNT_SAVE
                ? <div className='title'>
                    <h2>ERROR: No se ha podido guardar.</h2>
                </div>
                : ''
            }
            <div className="title">
                <h2>Expediente nº {num}</h2>
                <h3>Estado: 
                    { expediente.abierto 
                        ? ' Abierto'
                        : ' Cerrado' 
                    }
                </h3>
                {! user.responsable_spiyv && <h3>Tipo de escenario: {expediente.escenario}</h3>}
            </div>

            { status === STATUS.UNSAVED
                ? <p className='reminder'>* Recuerda guardar los cambios para no perderlos.</p>
                : ''
            }
            <div className="buttons-line">
                <button id="guardar" onClick={onClickHandler}>Guardar cambios</button>
                <button id="expediente"  onClick={onClickHandler}>Volver al expediente</button>
            </div>
            
            <div className='content'>
                <form>
                    <h3>Datos de registro:</h3>
                    {user.responsable_spiyv && <div>
                        <label htmlFor="escenario">Escenario:</label>
                        <select id="escenario" name="escenario"
                            value={expediente.escenario || ''}
                            onChange={onChangeHandler}>
                            <option value=""></option>
                            {escenarios.map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select>
                    
                        <label htmlFor="plataforma">Plataforma:</label>
                        <select id="plataforma" name="plataforma"
                            value={expediente.plataforma || ''}
                            onChange={onChangeHandler}>
                            {plataformas.map((option, index) => (
                                <option key={index} value={option}>
                                    {option}
                                </option>
                            ))}
                        </select> {responsable && <p className="responsable_plataforma">Responsable: {`${responsable}`}</p>}
                    </div>}
                    <label htmlFor="fecha_apertura">Fecha de apertura:</label>
                    <input type="date" readOnly id="fecha_apertura" name="fecha_apertura"
                        value={expediente.fecha_apertura || ''}/>

                    <h3>Registro de actuaciones:</h3>
                    <Actuaciones editable={true} />

                    <h3>Resultados:</h3>
                    <label htmlFor="medidas">Medidas adoptadas:</label>
                    <ul>
                        { expediente.medidas !== undefined && expediente.medidas.length > 0
                            ? expediente.medidas.map((m, index) => (
                                <li key={index}>{`${m.texto_medida} -- Escrita por ${m.escrito_por}`}</li>
                            ))
                            : ''
                        }
                    </ul>
                    Consignar medida:
                    <textarea id="medidas" name="medidas"
                        onChange={onChangeHandler}>
                        {medida}
                    </textarea>
                    <label htmlFor="resultados">Resultados de las medidas:</label>
                    <ul>
                        { expediente.resultados !== undefined && expediente.resultados.length > 0
                            ? expediente.resultados.map((r, index) => (
                                <li key={index}>{`${r.texto_resultado} -- Escrito por ${r.escrito_por}`}</li>
                            ))
                            : ''
                        }
                    </ul>
                    Consignar resultado:
                    <textarea id="resultados" name="resultados"
                        onChange={onChangeHandler}>
                        {resultado}
                    </textarea>

                    { user.responsable_spiyv && <div>
                        <h3>Cierre:</h3>
                        <div>
                            <label htmlFor="cierre.motivo_cierre">Motivo de cierre del expediente:</label>
                            <select id="cierre.motivo_cierre" name="motivo_cierre"
                                value={expediente.cierre?.motivo_cierre || ''}
                                onChange={onChangeHandler}>
                                {motivosCierre.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <label htmlFor="cierre.fecha_medida">Fecha de la medida que origina la propuesta de cierre:</label>
                        <input type="date" id="cierre.fecha_medida" name="fecha_medida"
                            value={expediente.cierre?.fecha_medida || ''}
                            onChange={onChangeHandler}/>
                        <label htmlFor="cierre.detalle_otras_medidas">En el caso de otras medidas, citar cuáles:</label>
                        <textarea id="cierre.detalle_otras_medidas" name="detalle_otras_medidas"
                            onChange={onChangeHandler}>
                            {expediente.cierre?.detalle_otras_medidas || ''}
                        </textarea>
                        <div id="checkbox">
                            <input type="checkbox" id="cierre.notificado_a_entidad_publica" name="notificado_a_entidad_publica"
                                onChange={onChangeHandler}
                                checked={notificadoEntidad}/>
                            <label id="checkbox" htmlFor="cierre.notificado_a_entidad_publica">Notificado a entidad pública</label>
                        </div>

                        <h3>Responsable del expediente:</h3>
                        <label htmlFor="nombre_responsable">Nombre:</label>
                        <input type="text" id="nombre_responsable" name="nombre_responsable"
                            value={expediente.cierre?.nombre_responsable || ''}
                        />
                        <label htmlFor="funcion_responsable">Función dentro del SdPI:</label>
                        <input type="text" id="funcion_responsable" name="funcion_responsable"
                            value={expediente.cierre?.funcion_responsable || ''}/>
                    
                        <h3>Catalogación estadística:</h3>
                        <div className="catalogacion" id="tipo_violencia">
                            <label htmlFor="clasificacion.tipo_violencia">Tipo de violencia:</label>
                            <select id="clasificacion.tipo_violencia" name="clasificacion.tipo_violencia"
                                value={expediente.clasificacion?.tipo_violencia || ''}
                                onChange={onChangeHandler}>
                                {tiposViolencia.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="catalogacion" id="ambito">
                            <label htmlFor="clasificacion.ambito">Ámbito:</label>
                            <select id="clasificacion.ambito" name="clasificacion.ambito"
                                value={expediente.clasificacion?.ambito || ''}
                                onChange={onChangeHandler}>
                                {ambitos.map((option, index) => (
                                    <option key={index} value={option}>
                                        {option}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="catalogacion" id="edad_persona_vulnerable">
                            <label htmlFor="clasificacion.edad_persona_vulnerable">Edad de la persona vulnerable:</label>
                            <input type="number" min="0" step="1" id="clasificacion.edad_persona_vulnerable" name="clasificacion.edad_persona_vulnerable"
                                value={expediente.clasificacion?.edad_persona_vulnerable || ''}
                                onChange={onChangeHandler}
                            />
                        </div>
                        <div className="catalogacion" id="sexo_persona_vulnerable">
                            <label htmlFor="clasificacion.sexo_persona_vulnerable">Sexo de la persona vulnerable:</label>
                            <select id="clasificacion.sexo_persona_vulnerable" name="clasificacion.sexo_persona_vulnerable"
                                value={expediente.clasificacion?.sexo_persona_vulnerable || ''}
                                onChange={onChangeHandler}>
                                <option value=""></option>
                                <option value="H">Hombre</option>
                                <option value="M">Mujer</option>
                            </select>
                        </div>
                    </div>}
                </form>
            </div>
            <div className="buttons-line">
                <button id="guardar2" onClick={onClickHandler}>Guardar cambios</button>
                {
                    user.responsable_spiyv &&
                    expediente.abierto &&
                    <button id="cerrar" onClick={onClickHandler}>Guardar y cerrar expediente</button>
                }
            </div>
            <p className='reminder'>
                {status === STATUS.SAVED
                    ? 'Cambios guardados'
                    : '* Hay cambios sin guardar.'
                }
            </p>
        </>
    );
}